import React, { PureComponent } from "react";
import VerticalSpace from "./components/VerticalSpace";
import Grid from "@material-ui/core/Grid";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import Button from "@material-ui/core/Button";
import { Route } from "react-router-dom";
import queryString from 'query-string';

export default class NetsFailed extends PureComponent {

    componentDidMount() {
        const query = decodeURIComponent(decodeURI(this.props.location.search));
        const values = queryString.parse(query);

        sessionStorage.removeItem(values.merchantTxnRef);
        sessionStorage.clear();
    }

    render() {
        const ConfirmButton = props => (
            <Route
                render={({ history }) => (
                    <div>
                        <Button
                            variant="outlined"
                            style={{ width: "100%" }}
                            onClick={() => {
                                history.push({
                                    pathname: "/"
                                });
                            }}
                        >
                            Proceed
            </Button>
                    </div>
                )}
            />
        );

        return (
            <div>
                <div className="account">
                    <div className="account__wrapper">
                        <div className="account__card">
                            <VerticalSpace />
                            <div className="card__title">
                                <center>
                                    <h4 className="bold-text">Payment</h4>
                                </center>
                                <br />
                            </div>
                            <form className="form form--horizontal">
                                <div className="form__form-group">
                                    <p>
                                        <b>Payment Failed</b>
                                    </p>
                                </div>
                                <div className="form__form-group">
                                    <p>Please try again ...</p>
                                </div>
                                <div className="form__form-group">
                                    <Grid container spacing={24}>
                                        <Grid item xs={3} />
                                        <Grid item xs={6}>
                                            <ConfirmButton />
                                        </Grid>
                                        <Grid item xs={3} />
                                    </Grid>
                                    <VerticalSpace />
                                </div>
                            </form>
                            <SimpleBottomNavigation value={1} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/main/NetsFailed.js